import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const bulkUpdateProductsFunc = createAsyncThunk(
  "bulkUpdateProductsSlicer/bulkUpdateProductsFunc",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await api.post(
        'dashboard/products/bulk-update',
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const bulkUpdateProductsSlicer = createSlice({
  name: "bulkUpdateProductsSlicer",
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(bulkUpdateProductsFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(bulkUpdateProductsFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(bulkUpdateProductsFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default bulkUpdateProductsSlicer.reducer;

